const schoolData = JSON.parse(localStorage.getItem('schoolData'))

function instanceModuleUsing(moduleName) {
  const availableModules = schoolData.config?.modules ?? []
  return availableModules.indexOf(moduleName) >= 0
}

export default instanceModuleUsing
